import { type CapacitorBarcodeScannerOptions, CapacitorBarcodeScanner, CapacitorBarcodeScannerAndroidScanningLibrary, CapacitorBarcodeScannerCameraDirection, CapacitorBarcodeScannerScanOrientation, CapacitorBarcodeScannerTypeHint, type CapacitorBarcodeScannerScanResult } from '@capacitor/barcode-scanner';

export async function scan() {
  if (usePlatformStore().isWeb) {
    const { openToast } = useUserMessages();
    const { t } = useEkI18n();
    const permissionGranted = await navigator.permissions.query({ name: 'camera' }).then(async (result) => {
      if (result.state === 'denied') {
        openToast(t('qa.couldNotOpenCamera'), ToastType.ERROR);

        return false;
      }

      if (result.state !== 'granted') {
        let stream: MediaStream | null = null;

        try {
          stream = await navigator.mediaDevices.getUserMedia({ video: true });
          // Immediately close the streams, we only need to make sure we have the camera permission.
          await new Promise<void>(resolve => {
            if (stream) {
              stream.getTracks().forEach(track => track.stop());
            }

            resolve();
          });
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (_) {
          openToast(t('qa.couldNotOpenCamera'), ToastType.ERROR);

          return false;
        }
      }
      
      return true;
    });

    if (!permissionGranted) {
      return;
    }
  }

  try {
    const { t } = useEkI18n();
    const settingsStore = useSettingsStore();
    const options: CapacitorBarcodeScannerOptions = {
      hint: CapacitorBarcodeScannerTypeHint.ALL,
      cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK,
      scanOrientation: CapacitorBarcodeScannerScanOrientation.ADAPTIVE,
      scanText: settingsStore._settings.showScannerButton ? t('materials.barcode.scan') : '',
      scanInstructions: settingsStore._settings.showScannerButton ? t('materials.barcode.buttonInstructions') : '',
      scanButton: settingsStore._settings.showScannerButton ? true : false,
      android: {
        scanningLibrary: CapacitorBarcodeScannerAndroidScanningLibrary.ZXING
      },
      web: {
        showCameraSelection: true,
        scannerFPS: 60
      }
    };

    // Start the scan
    const result: CapacitorBarcodeScannerScanResult = await CapacitorBarcodeScanner.scanBarcode(options);

    // If a barcode is detected
    if (result.ScanResult) {
      return result.ScanResult;
    }
  } catch {
    return;
  }
}
